import type { ProductPropertyKey } from "@/features/sub-families/types";
import {
    getEmptyConfigCode,
    getSmartNumberDescriptorByProductProperty,
} from "@/features/sub-families/utils/smart-number.ts";
import { useAppSelector } from "@/redux/store.ts";
import type { SmartNumberDescriptorKey } from "@/types";

export default function useConfigCode() {
    const smartNumberMapping = useAppSelector((state) => state.smartNumber.mapping);
    const smartNumberDescription = useAppSelector((state) => state.smartNumber.description);

    const getConfigCodeByDescriptor = (descriptor: SmartNumberDescriptorKey) => {
        return smartNumberMapping?.[descriptor] ?? null;
    };

    const getConfigCodeByProperty = (property: ProductPropertyKey) => {
        const descriptor = getSmartNumberDescriptorByProductProperty(property);
        if (!descriptor) return null;

        return getConfigCodeByDescriptor(descriptor);
    };

    const getEmptyConfigCodeByDescriptor = (descriptor: SmartNumberDescriptorKey) => {
        return getEmptyConfigCode(descriptor, smartNumberDescription);
    };

    const getEmptyConfigCodeByProperty = (property: ProductPropertyKey) => {
        const descriptor = getSmartNumberDescriptorByProductProperty(property);
        if (!descriptor) return null;

        return getEmptyConfigCode(descriptor, smartNumberDescription);
    };

    return {
        getConfigCodeByDescriptor,
        getConfigCodeByProperty,
        getEmptyConfigCodeByDescriptor,
        getEmptyConfigCodeByProperty,
    };
}
